module.exports = __webpack_public_path__ + "img/02.4ba2ce18.jpg";